const getters = {
    isSaleProductsCacheValid: (state, getters, rootState) =>
        Boolean(state.saleProducts.data) &&
        Boolean(state.saleProducts.expiredAt) &&
        Date.now() < state.saleProducts.expiredAt &&
        state.saleProducts.tenantId === rootState.auth.tenantId
};

export default getters;
